import React from 'react';
import IconSmile from '@/assets/IconSmile.svg';

import { THeader } from '@/services/requests/Recommendation/types/template5';

export function Header({ data }: { data: THeader }) {
  const { prefix, has_icon, suffix } = data;

  return (
    <div className="vitrine-template5__header">
      <div className="vitrine-template5__header--content">
        <span
          className="vitrine-template5__header--content-title1"
          data-testid="prefix"
        >
          {prefix}
        </span>
        {has_icon === 'true' && (
          <span
            className="vitrine-template5__header--content-icon"
            data-testid="icon"
          >
            <img src={IconSmile} alt="Smile" />
          </span>
        )}
        <span className="vitrine-template5__header--content-title2">
          <strong data-testid="suffix">{suffix}</strong>
        </span>
      </div>
    </div>
  );
}
